exports = module.exports = require("../../../../../shared/frontend/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.dropdown-toggle[data-v-2328522c]::after {\n  /*display: none !important;*/\n}\n.infinity-loading[data-v-2328522c] {\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.cursor-pointer[data-v-2328522c] {\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-2328522c","scoped":true,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/sass-loader?{"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 781
// module chunks = 1